export default (status) => ['unenrolled', 'pending_removal'].includes(status);
